import useTheme from 'chat-ui/src/hooks/useTheme';
import useTranslation from '@/hooks/useTranslation';

interface FetchErrorStateProps {
  /** Retry handler — typically the failing query's `refetch`. */
  onRetry?: () => void;
  /** Extra classes for the wrapper (e.g. tighter padding inside panels). */
  className?: string;
}

/**
 * Honest error state for failed data fetches (TELV1-544). A failed query
 * must never masquerade as an empty state ("No results", a blank report) —
 * that reads as data loss to researchers. Pair with the global query-error
 * toast in root.tsx; use this wherever a view's primary data failed.
 */
function FetchErrorState({ onRetry, className = '' }: FetchErrorStateProps) {
  const { lang } = useTranslation();
  const { currentTheme } = useTheme();

  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 p-10 text-center ${className}`}
    >
      <p className="text-sm text-gray-600">{lang.get('msg.somethingWentWrong')}</p>
      {onRetry && (
        <button
          type="button"
          className="text-sm font-medium underline"
          style={{ color: currentTheme?.primary }}
          onClick={onRetry}
        >
          {lang.get('msg.retry')}
        </button>
      )}
    </div>
  );
}

export default FetchErrorState;
